import { render, staticRenderFns } from "./ProjectHeader.vue?vue&type=template&id=1a5408be"
import script from "./ProjectHeader.vue?vue&type=script&lang=ts"
export * from "./ProjectHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a5408be')) {
      api.createRecord('1a5408be', component.options)
    } else {
      api.reload('1a5408be', component.options)
    }
    module.hot.accept("./ProjectHeader.vue?vue&type=template&id=1a5408be", function () {
      api.rerender('1a5408be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/projects/ProjectHeader.vue"
export default component.exports